import UploadDual  from  './UploadDual'

export default UploadDual